import { getRegionConfig } from 'config';
import { Region } from 'constants/shop';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import { IBlogAuthorFields, IBlogCategoryFields, IBlogPostFields } from 'global';

/** Format date for magazine */
export const formatDate = (dateString: string): string | null => {
  try {
    return format(new Date(dateString), 'dd.MM.yyyy', {
      locale: de,
    });
  } catch (error) {
    return null;
  }
};

interface AuthorPathInput {
  author: Pick<IBlogAuthorFields, 'handle'>;
}

interface MainPathInput {
  mainCategory: Pick<IBlogCategoryFields, 'handle'>;
}

type SubPathInput = {
  subCategory: Pick<IBlogCategoryFields, 'handle'>;
} & MainPathInput;

type BlogPostPath = {
  blogPost: Pick<IBlogPostFields, 'handle'> | string;
} & SubPathInput;

type MagazineFullUrlInput = AuthorPathInput | MainPathInput | SubPathInput | BlogPostPath;

/** Generate url or path for magazine path  */
export const getMagazineUrl = (
  urlConfig?: MagazineFullUrlInput,
  /** if it's true, it returns full url domain */
  fullUrl = false,
  region: Region = Region.DE
): string => {
  const urlElements: Array<string> = [];
  const { frontendUrl, magazineBasePath } = getRegionConfig(region);

  if (fullUrl) {
    urlElements.push(frontendUrl);
  }
  urlElements.push(`${magazineBasePath}`);

  if (urlConfig && 'author' in urlConfig) {
    urlElements.push('author', `${urlConfig.author.handle}`);
  } else if (urlConfig && 'mainCategory' in urlConfig) {
    urlElements.push(`${urlConfig.mainCategory.handle}`);
    'subCategory' in urlConfig && urlElements.push(`${urlConfig.subCategory.handle}`);
    if ('blogPost' in urlConfig) {
      if (typeof urlConfig.blogPost !== 'string') {
        urlElements.push(`${urlConfig.blogPost.handle}`);
      } else {
        urlElements.push(`${urlConfig.blogPost}`);
      }
    }
  }

  let rtnUrl = urlElements.join('/');

  // if full url is not intended, add '/' so that it's compatible to subpath
  if (!fullUrl) {
    rtnUrl = `/${rtnUrl}`;
  }

  return rtnUrl;
};
